import type { UserType } from '@shared/auth/index.js';
import type { IntakeStatusNote } from '@shared/patient-intake-status';

type DetermineIfUserCanSeeNoteParams = {
  userType: UserType | '';
  visibility: IntakeStatusNote['visibility'];
};

export const determineIfUserCanSeeNote = ({ userType, visibility }: DetermineIfUserCanSeeNoteParams) => {
  if (!userType || !visibility) {
    return false;
  }

  if (userType === 'patient') {
    return visibility.isVisibleToPatient;
  }

  if (userType === 'support') {
    return !visibility.isMedicalNote;
  }

  return true;
};
